import { KeyValueModel } from "../../model";
import { EnumTpSituacao } from "../../model/enums/enum-tp-situacao";

export const TpSituacaoMock: KeyValueModel[] = [
  new KeyValueModel(EnumTpSituacao.Inativa, "Inativa"),
  new KeyValueModel(EnumTpSituacao.Ativa, "Ativa"),
  new KeyValueModel(EnumTpSituacao.Desativada, "Desativada"),
  new KeyValueModel(EnumTpSituacao.DesativadaSaurus, "Desativada Saurus"),
];
